import React, { useState, useEffect, useCallback } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import WebTopBar from '../components/WebTopBar.js';
import Icon from '../components/Icon.js';
import { DCard, BtnGhost } from '../components/MarketplaceAtoms.js';
import { fetchUserSolicitudes, solicitudFmtDate } from '../../lib/userSolicitudesService.js';

const STATUS_COLORS = {
  pending: C.gold,
  reviewing: '#85B7EB',
  approved: C.green,
  rejected: C.danger,
  active: C.green,
  pending_approval: C.gold,
};

function kindLabel(kind) {
  if (kind === 'partner_account') return 'Partner';
  if (kind === 'partner_role') return 'Rol partner';
  if (kind === 'comunidad_portada') return 'Comunidad';
  if (kind === 'comunidad_moderacion') return 'Comunidad';
  return 'Solicitud';
}

export default function PageMisSolicitudes({ onBack, onNavigate, user }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(!!user?.id);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    if (!user?.id) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setErr('');
    const { items: list, error } = await fetchUserSolicitudes(user.id);
    if (error) setErr(error);
    else setItems(list);
    setLoading(false);
  }, [user?.id]);

  useEffect(() => {
    load();
  }, [load]);

  const openItem = item => {
    if (!item?.navigatePage) return;
    if (item.navigateData?.comunidadId) {
      onNavigate?.(item.navigatePage, { comunidadId: item.navigateData.comunidadId });
    } else {
      onNavigate?.(item.navigatePage);
    }
  };

  return (
    <div style={{ background: C.dark, minHeight: '100vh', color: '#fff' }}>
      <WebTopBar onBack={onBack} title="Mis solicitudes" mini dark user={user} onNavigate={onNavigate} onSignOut={onBack} />
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '20px 20px 60px' }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', lineHeight: 1.5, marginBottom: 16 }}>
          Estado de todo lo que has enviado a DreamVinyl: partner, roles, publicaciones y portadas en Comunidad.
        </p>

        {!user?.id ? (
          <DCard style={{ padding: 16 }}>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Inicia sesión para ver tus solicitudes.</div>
          </DCard>
        ) : loading ? (
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Cargando…</div>
        ) : err ? (
          <DCard style={{ padding: 16 }}>
            <div style={{ fontSize: 12, color: C.warn, marginBottom: 10 }}>{err}</div>
            <BtnGhost onClick={load}>Reintentar</BtnGhost>
          </DCard>
        ) : !items.length ? (
          <DCard style={{ padding: 20, textAlign: 'center' }}>
            <Icon name="check" size={28} color={C.green} />
            <div style={{ fontSize: 14, color: '#fff', marginTop: 12, fontWeight: 500 }}>Sin solicitudes abiertas</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 8, lineHeight: 1.5 }}>
              Cuando envíes una alta de partner, un rol o una solicitud en Comunidad, aparecerá aquí con su estado.
            </div>
          </DCard>
        ) : (
          items.map(item => {
            const color = STATUS_COLORS[item.status] || 'rgba(255,255,255,0.5)';
            return (
              <DCard
                key={item.id}
                style={{
                  padding: '14px 16px',
                  marginBottom: 10,
                  cursor: 'pointer',
                  borderColor: item.status === 'pending' || item.status === 'pending_approval' ? 'rgba(200,168,75,0.25)' : undefined,
                }}
                onClick={() => openItem(item)}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      background: 'rgba(200,168,75,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <Icon name="info" size={16} color={C.gold} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                      <span style={{ fontSize: 9, textTransform: 'uppercase', letterSpacing: 0.5, color: 'rgba(255,255,255,0.35)' }}>
                        {kindLabel(item.kind)}
                      </span>
                      <span style={{ fontSize: 10, fontWeight: 600, color }}>{item.statusLabel}</span>
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>{item.title}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{item.subtitle}</div>
                    {item.detail ? (
                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 8, lineHeight: 1.45 }}>{item.detail}</div>
                    ) : null}
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.28)', marginTop: 8 }}>
                      {solicitudFmtDate(item.updatedAt || item.createdAt)}
                    </div>
                  </div>
                  <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: 16, flexShrink: 0 }}>›</span>
                </div>
              </DCard>
            );
          })
        )}
      </div>
    </div>
  );
}
